import "nprogress/nprogress.css";
import "@Shared/@Styles/bootstrap";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import "toastr/build/toastr.min.css";
import "select2/dist/css/select2.min.css";
import "select2-bootstrap4-theme/dist/select2-bootstrap4.css";
import "@Shared/@Styles/style";
import "bootstrap4c-dropzone/dist/css/component-dropzone.min.css";
import "animate.css/animate.min.css";
import "@Shared/@Styles/navbars";
import "@Shared/@Styles/dashboard";
import "@Shared/@Styles/documents";
import "@Shared/@Styles/login";
import "@Shared/@Styles/loading";
import "@Shared/@Styles/responsive";
import "@Client/@Styles/app";
import "@Client/@Styles/dashboard";
import "@Client/@Styles/color";
import "@Client/@Styles/mortgage-app";
import "@Shared/@Styles/application";
import "@Client/@Styles/main";
import "@Shared/@Styles/override";
import "@Shared/@Styles/grid";
import "cropperjs/dist/cropper.css";
import "jquery";
window.$ = $;
import "@doorr/parsleyjs";
import "@doorr/parsleyjs/dist/i18n/fr";
import "@doorr/parsleyjs/dist/i18n/en";
import "jquery-serializejson/jquery.serializejson.min.js";
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js";
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min.js";
import "popper.js/dist/umd/popper.min.js";
import "bootstrap";
import "select2/dist/js/select2.full.min.js";
import "select2/dist/js/i18n/fr.js";
import "better-timezone-latest/src/better-timezone.js";
import "parse-address/parse-address.min.js";
import "numeral/locales/fr-ca";
import "@Shared/@Utils/configure-plugins";
import "./js/index";